import React, { useState } from "react";
import slackLogo from "assets/img/icons/slack-new-logo.svg";
import Loader from "components/Loader";
import { Modal } from "react-responsive-modal";
import Button from "components/CustomButton";
import TeamService from "services/TeamService";

const useStyles = {
  slackButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 10px",
    height: "50px",
    color: "black",
    boxShadow: "0 0px 5px 0 rgb(0 0 0 / 27%), 0 0px 3px 0 rgb(0 0 0 / 63%)",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    maxWidth: "505px",
    width: "100%",
    marginTop: "20px",
    "&:hover": {
      boxShadow: "0 4px 10px 0 rgb(0 0 0 / 7%), 0 2px 10px 0 rgb(0 0 0 / 36%)",
    },
  },
  buttonName: {
    color: '#575F6B',
    fontFamily: "system-ui",
    fontSize: "larger",
    fontWeight: "400",
    textTransform: "capitalize",
  },
  slackLogoIcon: {
    maxWidth: "24px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
};

export default ({ team }) => {
  const classes = useStyles;
  const [loading, setLoading] = useState(false);
  const [confimSlack, setConfirmSlack] = useState(false);
  const loaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  const goToSlack = async () => {
    try {
      setLoading(true);
      var response = await TeamService.getSlackPath(team.id);
      window.location.href = response.data.url;
      setLoading(false);
      setConfirmSlack(false);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div style={classes.slackButton} onClick={() => setConfirmSlack(true)}>
        <span style={classes.buttonName}>Connect To Slack</span>
        <div style={classes.slackLogoIcon}>
          <img src={slackLogo} alt="slackLogo" style={{ width: "18px" }} />
        </div>
      </div>
      <Modal
        open={confimSlack}
        onClose={() => setConfirmSlack(false)}
        showCloseIcon={false}
        classNames={{ modalContainer: "modalContainer", modal: "slackModal" }}
      >
        <div className="modalHeader">Slack</div>
        <div className="modalContent">
          {loading && (
            <div style={loaderStyle}>
              <Loader />
            </div>
          )}
          {!loading && (
            <div>Do you want to connect to slack, kindly confirm.</div>
          )}
        </div>
        <div className="modalAction">
          <Button
            buttonClass="small-btn me-2"
            onClick={() => {
              setConfirmSlack(false);
            }}
          >
            Cancel
          </Button>
          <Button
            buttonClass=" small-accept-btn "
            name={!loading ? "Confirm" : <Loader width={25} height={25} />}
            disabled={loading && true}
            onClick={goToSlack}
            value="confirm"
            style={{ background: "#CA2E20" }}
          />
        </div>
      </Modal>
    </>
  );
};
